<template>
    <div>
        <div id="refresh-page-modal" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered square-modal">
                <div class="modal-content">
                    <div class="modal-header d-flex flex-column align-items-center text-center p-0">
                        <img :src="require('../assets/images/massive-sent.png')" alt="" width="95" height="95"/>
                        <h3 class="modal-title mx-3">{{ $t('refresh-modal-title') }}</h3>
                    </div>
                    <div class="modal-body text-center p-0 pt-3 px-4">
                        <div>
                            {{ $t('refresh-modal-body-1') }}
                        </div>
                        <div>
                            {{ $t('refresh-modal-body-2') }}
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center p-0 pt-3">
                        <button type="button" class="btn btn-primary rounded-pill" @click="refreshPage()">
                            {{ $t('refresh-modal-button') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { mapActions, mapState } from 'vuex';

export default {
    name:     'refresh-modal',
    computed: {
        /**
         * Version state
         */
        ...mapState('core/version', ['version'])

    },
    mounted () {
        this.modal = new Modal(this.$el.querySelector('#refresh-page-modal'), {
            backdrop: 'static',
            keyboard: false
        });

        this.modal.show();
    },
    methods: {
        ...mapActions('core/version', ['setVersionFromJson']),

        async refreshPage () {
            const version = await this.setVersionFromJson();

            if (version) {
                this.modal.hide();
                window.location.reload();
            }
        }
    }
};

</script>

<style>
.square-modal {
  width: 447px !important;
}

.modal-title {
    font-family: 'Nunito Bold', sans-serif;
    font-size: 24px;
}

.modal-content {
    font-size: 13px;
    height: auto;
    padding: 34px;
}

.modal-footer button {
    font-family: 'Nunito Bold', sans-serif;
    font-size: 14px !important;
    padding: 10px 20px;
}
</style>
